import { UIButton, UIButtonProps } from "./Button";

export type UIIconButtonProps = UIButtonProps;

export const UIIconButton = ({ children, ...props }: UIIconButtonProps) => (
  <UIButton variant="text" shape="circle" {...props}>
    {children}
  </UIButton>
);
